import { router } from 'app/agriculture/router/router';
import { ServicesContext } from 'app/items/shared/context_interface';
import { RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { ErrorPage } from './agriculture/routes/ErrorPage';

export function App() {
    return (
        <Sentry.ErrorBoundary fallback={<ErrorPage />} showDialog>
            <ServicesContext.Provider value={window.services}>
                <RouterProvider router={router} />
            </ServicesContext.Provider>
        </Sentry.ErrorBoundary>
    );
}
